import CareServiceRequestResult from 'features/CareServiceRequestResult'

export default (props) => <CareServiceRequestResult {...{
  ...props,
  careOptionName: 'Telemedicine'
}} />
